export default {
    "W22": "28th May – 03rd June",
    "W23": "04th June – 10th June",
    "W24": "11th June – 17th June",
    "W25": "18th June – 24th June",
    "W26": "25th June – 01st July",
    "W27": "02nd July – 08th July",
    "W28": "09th July – 15th July",
    "W29": "16th July – 22nd July",
    "W30": "23rd July – 29th July",
    "W31": "30th July – 05th Aug",
    "W32": "06th Aug – 12th Aug",
    "W33": "13th Aug – 19th Aug",
    "W34": "20th Aug – 26th Aug",
    "W35": "27th Aug – 02nd Sept",
    "W36": "03rd Sept – 09th Sept",
    "W37": "10th Sept – 16th Sept",
    "W38": "17th Sept – 23rd Sept",
    "W39": "24th Sept – 30th Sept",
    "W40": "01st Oct – 07th Oct",
    "W41": "08th Oct – 14th Oct",
    "W42": "15th Oct – 21st Oct",
    "W43": "22nd Oct – 28th Oct",
    "W44": "29th Oct – 04th Nov",
    "W45": "05th Nov – 11th Nov",
    "W46": "12th Nov – 18th Nov",
    "W47": "19th Nov – 25th Nov",
    "W48": "26th Nov – 02nd Dec",
    "W49": "03rd Dec – 09th Dec",
    "W50": "10th Dec – 16th Dec",
    "W51": "17th Dec – 23rd Dec",
    "W52": "24th Dec – 31st Dec"
    };